"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const node_1 = require("./node");
class NumberNode extends node_1.default {
    static from(obj) {
        if (obj['type'] === 'number')
            return new NumberNode(obj['value']);
        return null;
    }
    constructor(value) {
        super();
        this.value = value;
    }
    serialize() {
        return {
            type: 'number',
            value: this.value,
        };
    }
    validate() {
        return this.value !== null && this.value !== undefined && !isNaN(this.value);
    }
    listColumns() {
        return [];
    }
}
exports.default = NumberNode;
